module.exports = __webpack_public_path__ + "img/arrow-down.2b708672.svg";